export default __webpack_public_path__ + "static/media/gear.c466482c.svg";